module.exports = [{"id":"1","form":"atendente","title":"Atendente","description":"","btnText":"Selecionar"}]


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/adminClipboards.json
// module id = 1309
// module chunks = 0